import React from 'react';
import { Toaster } from 'react-hot-toast';

const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      {children}
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Default options for all toasts
          duration: 4000,
          style: {
            background: '#fff',
            color: '#374151',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            padding: '16px',
            fontSize: '14px',
            fontWeight: '500',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            maxWidth: '400px',
          },
          // Dark mode styles
          className: '',
          // Success toasts
          success: {
            duration: 3000,
            style: {
              background: '#f0fdf4',
              color: '#166534',
              border: '1px solid #bbf7d0',
            },
            iconTheme: {
              primary: '#16a34a',
              secondary: '#f0fdf4',
            },
            className: 'dark:bg-green-950 dark:text-green-100 dark:border-green-800',
          },
          // Error toasts
          error: {
            duration: 5000,
            style: {
              background: '#fef2f2',
              color: '#dc2626',
              border: '1px solid #fecaca',
            },
            iconTheme: {
              primary: '#dc2626',
              secondary: '#fef2f2',
            },
            className: 'dark:bg-red-950 dark:text-red-100 dark:border-red-800',
          },
          // Loading toasts
          loading: {
            style: {
              background: '#f8fafc',
              color: '#475569',
              border: '1px solid #e2e8f0',
            },
            iconTheme: {
              primary: '#3b82f6',
              secondary: '#f8fafc',
            },
            className: 'dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700',
          },
        }}
      />
    </>
  );
};

export default ToastProvider;